import { Star } from "lucide-react";

const awards = [
  { icon: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/542c3a712_Superhost-logo-CMYK-Transparent1.png", title: "Airbnb Superhosts", body: "Superhost status across multiple accounts." },
  { icon: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/9a12e99b9_34.png", title: "5/5 on Trustpilot", body: "Every Trustpilot reviewer awarded us 5 stars." },
  { icon: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/10b479687_Flat-611-67-Trafford-Gardens-NEW-Marketing-Images-e1778689639948.png", title: "Airbnb Guest Favourites", body: "Many of our homes are in the top 10% on Airbnb." },
  { icon: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/9dfe061df_43.png", title: "5/5 on Google", body: "96 Google reviews. All five stars." },
  { icon: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/1456af477_94.png", title: "Booking.com Awards", body: "Traveller award winners — consistently." },
];

const testimonials = [
  {
    avatar: "https://i.pravatar.cc/80?img=33",
    quote: "I was earning £950 a month from a long-term tenant. Within 60 days of handing it to Truestays I was clearing over £1,800. I genuinely don't have to do anything.",
    name: "James R.",
    detail: "1-bed apartment",
    type: "landlord",
  },
  {
    avatar: "https://i.pravatar.cc/80?img=45",
    quote: "Professional photos done within a week, live on Airbnb by day 7, first payout by day 30. Exactly as they promised.",
    name: "Sarah M.",
    detail: "2-bed apartment",
    type: "landlord",
  },
  {
    avatar: "https://i.pravatar.cc/80?img=12",
    quote: "Nervous about switching from a long-term tenant but they walked me through everything. First year with Truestays was the best financial year we've had from that property.",
    name: "Mark T.",
    detail: "3-bed house",
    type: "landlord",
  },
];

const pad = "clamp(20px, 5vw, 80px)";

export default function ManchesterReviews() {
  return (
    <section style={{
      backgroundColor: "#F4F1E7",
      paddingTop: "clamp(60px, 8vw, 100px)",
      paddingBottom: "clamp(60px, 8vw, 100px)",
      paddingLeft: pad,
      paddingRight: pad,
    }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        {/* Header */}
        <div style={{ marginBottom: 40 }}>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C7268", marginBottom: 10, marginTop: 0 }}>Award Winning</p>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: 24, flexWrap: "wrap" }}>
            <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(26px, 3vw, 40px)", color: "#112215", lineHeight: 1.15, letterSpacing: "-0.02em", marginBottom: 0, marginTop: 0 }}>
              Loved by landlords and guests
            </h2>
            <div style={{ display: "flex", alignItems: "center", gap: 20, flexWrap: "wrap" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ display: "flex", gap: 2 }}>
                  {[1,2,3,4,5].map(i => <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill="#FBBF24" stroke="#FBBF24" strokeWidth="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>)}
                </div>
                <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, color: "#5C7268", fontWeight: 600 }}>5.0 on Google</span>
              </div>
              <span style={{ color: "#D5D5D5" }}>·</span>
              <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, color: "#5C7268", fontWeight: 600 }}>35,000+ stays managed</span>
            </div>
          </div>
        </div>

        {/* Award cards */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 12, marginBottom: 32 }} className="award-cards-grid">
          {awards.map(({ icon, title, body }) => (
            <div key={title} style={{ background: "#fff", border: "1px solid #E8E4D5", borderRadius: 12, padding: "20px 16px" }}>
              <img src={icon} alt={title} style={{ width: "auto", maxWidth: "100%", height: 48, objectFit: "contain", marginBottom: 14, display: "block" }} />
              <div style={{ height: 1, background: "#E8E4D5", marginBottom: 14 }} />
              <h3 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 14, color: "#112215", marginBottom: 6, marginTop: 0, lineHeight: 1.3 }}>{title}</h3>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 12, color: "#5C7268", lineHeight: 1.5, margin: 0 }}>{body}</p>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }} className="testimonials-grid">
          {testimonials.map((t) => (
            <div key={t.name} style={{
              background: "#fff",
              border: "1px solid #E8E4D5",
              borderRadius: 14,
              padding: "22px 22px 20px",
              display: "flex", flexDirection: "column",
              transition: "box-shadow 0.2s",
            }}
            onMouseEnter={e => e.currentTarget.style.boxShadow = "0 8px 28px rgba(0,0,0,0.07)"}
            onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}
            >
              <div style={{ display: "flex", gap: 2, marginBottom: 14 }}>
                {[1,2,3,4,5].map(i => <Star key={i} size={12} color="#FBBF24" fill="#FBBF24" />)}
              </div>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, color: "#112215", lineHeight: 1.65, flex: 1, marginBottom: 18, marginTop: 0 }}>"{t.quote}"</p>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <img src={t.avatar} alt={t.name} style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
                <div>
                  <p style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 13, color: "#112215", marginBottom: 2, marginTop: 0 }}>{t.name}</p>
                  <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, color: "#5C7268", margin: 0 }}>{t.detail}</p>
                </div>
                <span style={{ marginLeft: "auto", fontSize: 10, fontWeight: 600, color: "#112215", background: "#CCF5AC", borderRadius: 100, padding: "2px 8px", fontFamily: "'Inter', sans-serif" }}>Landlord</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 1200px) { .award-cards-grid { grid-template-columns: repeat(3, 1fr) !important; } }
        @media (max-width: 768px) { .award-cards-grid { grid-template-columns: repeat(2, 1fr) !important; } .testimonials-grid { grid-template-columns: 1fr !important; } }
        @media (max-width: 500px) { .award-cards-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}